/**
 * The viewer's IANA time zone as their browser reports it ('Asia/Kolkata', 'Europe/London'), or null when the browser
 * does not say. Sent with the chat's messages so the assistant's "today" in a chat with no client (the portfolio) is
 * the rep's own day, wherever they work; the server ignores a zone it does not know and then says UTC.
 */
export default function viewer_time_zone() {
    try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return typeof tz === 'string' && tz ? tz : null;
    } catch (e) {
        return null;
    }
}
